import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=6716665b&scoped=true&"
import script from "./Galleries.vue?vue&type=script&lang=js&"
export * from "./Galleries.vue?vue&type=script&lang=js&"
import style0 from "./Galleries.vue?vue&type=style&index=0&id=6716665b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716665b",
  null
  
)

export default component.exports